<template>
  <div class="container">
    <button
      class="ZoomPlus"
      @mouseup="Zoom(1)"
    >
      <div class="Icon PlusIcon" />
    </button>
    <button
      class="ZoomMinus"
      @mouseup="Zoom(-1)"
    >
      <div class="Icon MinusIcon" />
    </button>
    <div class="borderObj" />
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js'

export default {
  methods: {
    Zoom (val) {
      EventBus.$emit('Zoom', val)
    }
  }

}
</script>

<style scoped>

button:hover {
background: rgb(240,240,240)
}

button:active {
background: rgb(230,230,230)
}

@media screen and (min-width: 1300px) {
.container {
    width: 48px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    pointer-events: auto;
       filter: drop-shadow(0 1mm 1mm rgb(0, 0, 0, 0.3));
}

.ZoomPlus{
    width: 100%;
    height: 48px;
    background: white;
    border-radius: 48px 48px 0 0;
    display: flex;
    justify-content: center;
}

.ZoomMinus{
    width: 100%;
    height: 48px;
    border-radius:  0 0 48px 48px;
    background: white;
        display: flex;
    justify-content: center;
}
}

@media screen and (max-width: 1300px) {
.container {
    width: 42px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    pointer-events: auto;
       filter: drop-shadow(0 1mm 1mm rgb(0, 0, 0, 0.3));
}

.ZoomPlus{
    width: 100%;
    height: 42px;
    background: white;
    border-radius: 42px 42px 0 0;
    display: flex;
    justify-content: center;
}

.ZoomMinus{
    width: 100%;
    height: 42px;
    border-radius:  0 0 42px 42px;
    background: white;
        display: flex;
    justify-content: center;
}
}

.borderObj {
    width: 60%;
    height: 1px;
    position: absolute;
    align-self: center;
    border-bottom: solid rgba(0,0,0,0.15) 1px;
}

.PlusIcon {
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  mask-image: url('../../../assets/icons/triangle.svg');
}

.PlusIcon {
  mask-image: url('../../../assets/icons/plus.svg');
}

.Icon {
    margin: auto;
    height: 50%;
    width: 50%;
  mask-repeat: no-repeat;
  mask-position: center;
  background: black;
  mask-size: contain;
}

.MinusIcon {
  mask-image: url('../../../assets/icons/minus.svg');
}
</style>
